// 获取所有单位中心，不分页
import request from "@/utils/request";

export function unitAllNoPage(that, project_id, func) {
  request({
    url: '/v1.0/iwrs/unit/all_no_page',
    method: 'get',
    params: {
      project_id: project_id
    }
  }).then(res => {
    if (res && res.code === 0) {
      func(res)
    } else {
      that.$message.error(res.msg)
    }
  }).catch(res => {
    console.log(res.msg)
    that.$message.error('请求失败')
  })
}


export function unitMyAllResearchCenter(that, project_id, func) {
  request({
    url: '/v1.0/iwrs/unit/all/research_center',
    method: 'get',
    params: {
      project_id: project_id
    }
  }).then(res => {
    if (res && res.code === 0) {
      func(res)
    } else {
      that.$message.error(res.msg)
    }
  }).catch(res => {
    console.log(res.msg)
    that.$message.error('请求失败')
  })
}
export function getSubjectByUnit(data) {
  return request({
    url: '/v1.0/iwrs/subject/select/fall_off/all',
    method: 'post',
    data
  })
}

export function getUnblindSubjectByUnit(params) {
  return request({
    url: '/v1.0/iwrs/subject/select/urgently_unblind/all',
    method: 'get',
    params
  })
}

